import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';

export default class QuoteSavedResource extends BaseResource {
  constructor() {
    super({ url: '/api/quotes/saved' });
  }

  list(params = { includes: 'items' }) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  create(params = { quote: '', name: '', includes: 'items' }) {
    const urlParams = objectToUrlParams(params);
    return super
      .post({}, { url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  load(quoteId, params = { quote_set: '', includes: 'items' }) {
    const urlParams = objectToUrlParams(params);
    return super
      .post({}, { url: `${this.url}/${quoteId}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  delete(quoteId) {
    return super
      .delete({ url: `${this.url}/${quoteId}` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
